import { render, staticRenderFns } from "./RequestedCoverageType.vue?vue&type=template&id=f8d8d1a8&"
import script from "./RequestedCoverageType.vue?vue&type=script&lang=js&"
export * from "./RequestedCoverageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports